/**
 * @param {string} path
 * @return {*}
 */
import {injectable} from "inversify";
import {getter} from "../helpers";
import Settings from "../settings/Settings";

@injectable()
class AudioVolumes {

    private _volumes: Record<string, any>;

    constructor() {}

    /**
     * @param {Array{Object}} gamesetTracks
     * @param {InitResult} initResult
     */
    init(gamesetTracks = [], settings: Settings) {

        let audioConfig = settings.getSoundBehavConfig();

        this._volumes = {};

        for (let track of gamesetTracks) {

            let trackVolume = 1;

            if(track.volume != null) {

                trackVolume = track.volume;

            } else if(track.classVol !== undefined) {

                if(track.classVol) {
                    trackVolume = getter(track.classVol)(audioConfig);
                }

            } else if(track.reference !== undefined) {

                if(track.reference in this._volumes) {
                    trackVolume = this._volumes[track.reference];
                } else {
                    let refTrack = this._getTrackByName(gamesetTracks, track.reference);
                    trackVolume = getter(refTrack.classVol)(audioConfig)
                }
            }

            this._volumes[track.name] = trackVolume;
        }

        for(let trackName in this._volumes) {
            if(this._volumes[trackName] < 0) {
                this._volumes[trackName] = 0;
            }
        }

        // console.log(this._volumes);
    }

    /**
     * @param {string} trackName
     * @returns {number}
     */
    get(trackName) {

        if(this._volumes[trackName] !== undefined) {
            return this._volumes[trackName];
        }

        return 0;
    }

    // getVolumes() {
    //     return this._volumes;
    // }

    _getTrackByName(tracks, name) {

        for(let track of tracks) {
            if(track.name == name) {
                return track;
            }
        }
    }
}

export default AudioVolumes;